module.exports = __webpack_public_path__ + "img/neimenggu.a88d4978.jpg";